import { Control } from '../../../../vas/business-objects/control/control.model';
import { ComplexControl } from '../../../../vas/controls/complex/complex-control.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const controlFormSubControlRemoveReducer = (
    state = initialState,
    action: actions.ControlFormSubControlRemove
): State => {
    return {
        ...state,
        controlForm: {
            control: new ComplexControl({
                ...state.controlForm.control,
                config: {
                    ...state.controlForm.control.config,
                    controls: (state.controlForm.control as ComplexControl).config.controls
                        .filter(c => c.id !== action.payload.control.id)
                        .map((c, sequence) => new Control({...c, sequence}))
                }
            })
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/control-form-sub-control-remove.reducer.ts